
import { MuiIcons } from "@osu/react-ui";

function ExternalLinkIcon(props = {}) {
  const { Icon, color, ...rest }  = {
    ...defaultProps,
    ...props
  }
  return (
    <Icon
    sx={(theme) => {
      return {
        fontSize: ".8em",
        position: "relative",
        top: "-0.5em",
        left: ".2em",
        color: color || theme.palette.text.secondary,
      };
    }}
      aria-label="opens in a new window"
      {...rest}
    />
  );
}

const defaultProps = {
  Icon: MuiIcons.OpenInNew
}

export default ExternalLinkIcon;
